import { Condition } from "@redotech/redo-model/return-flow/condition";
import { validateExtendedWarrantyPurchasedCondition } from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type ExtendedWarrantyPurchasedState = void;

export const EXTENDED_WARRANTY_PURCHASED = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<ExtendedWarrantyPurchasedState>
  >,
): ConditionType<
  ExtendedWarrantyPurchasedState,
  Condition.ExtendedWarrantyPurchased
> => ({
  name: "Extended warranty purchased",
  description() {
    return "Extended warranty purchased";
  },
  Details(props: ConditionTypeDetailsProps<ExtendedWarrantyPurchasedState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.EXTENDED_WARRANTY_PURCHASED };
  },
  valid() {
    return validateExtendedWarrantyPurchasedCondition({}).valid;
  },
});
